/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 6e56ba5af02a4dda82b7fd39ecfcca4fa6a4f67f2b1d0cca125df49d71da6e0d
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Checkbox.style'

export type CheckboxProps = {
  className?: string
  checked?: boolean
  disabled?: boolean
  error?: boolean
  indeterminate?: boolean
  'aria-checked'?: never
  'aria-invalid'?: never
  children?: never
  defaultChecked?: never
  type?: never
} & Omit<
  ComponentProps<'input'>,
  | 'aria-checked'
  | 'aria-invalid'
  | 'checked'
  | 'children'
  | 'className'
  | 'defaultChecked'
  | 'disabled'
  | 'type'
>

function Checkbox(props: CheckboxProps): ReactElement {
  const {
    checked = false,
    className = '',
    disabled = false,
    error = false,
    indeterminate = false,
    readOnly,
    ...rest
  } = props
  const inputRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  React.useEffect(() => {
    inputRef.current?.setCustomValidity(
      error ? 'Your input is invalid.' : '',
    )
  }, [error])

  return (
    <span
      className={cn('Checkbox', className, { checked, 'not-checked': !checked, disabled, error, indeterminate })}
      css={style}
    >
      <input
        {...rest}
        aria-checked={indeterminate ? 'mixed' : checked}
        aria-invalid={error ? true : undefined}
        checked={checked}
        className='input'
        disabled={disabled}
        readOnly={readOnly ?? !rest.onChange}
        ref={inputRef}
        type='checkbox'
      />
      <span aria-hidden={true} className='indicator' />
    </span>
  )
}

export default Checkbox
